'use es6';

const CACHED_SEARCH_VALUES_KEY = 'ecosystem-marketplace-apps:searches';
export const getCachedSearchValues = () => {
  try {
    const parsedItem = JSON.parse(localStorage.getItem(CACHED_SEARCH_VALUES_KEY) || '[]');
    return Array.isArray(parsedItem) ? parsedItem : [];
  } catch (e) {
    return [];
  }
};
export const cacheSearchValue = searchValue => {
  const cachedValues = getCachedSearchValues();

  if (cachedValues.includes(searchValue)) {
    return;
  }

  try {
    localStorage.setItem(CACHED_SEARCH_VALUES_KEY, JSON.stringify([searchValue, ...cachedValues].slice(0, 4)));
  } catch (e) {
    return;
  }
};